var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebp = function SvgWebp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#21852B",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m4.342 17.5-1.04-3.636h.84l.601 2.526h.03l.665-2.526h.719l.662 2.532h.032l.602-2.532h.84L7.253 17.5h-.75l-.692-2.377h-.029l-.69 2.377zm4.362 0v-3.636h2.45v.633h-1.68v.867h1.554v.634H9.474v.868h1.689v.634zm3.062 0v-3.636h1.456q.4 0 .67.119.267.119.402.33.135.21.135.483a.735.735 0 0 1-.32.637 1 1 0 0 1-.337.144v.036a.83.83 0 0 1 .685.42.9.9 0 0 1 .114.462.95.95 0 0 1-.144.517.97.97 0 0 1-.42.357 1.6 1.6 0 0 1-.688.131zm.769-.629h.626q.321 0 .47-.122a.41.41 0 0 0 .146-.33.5.5 0 0 0-.072-.267.5.5 0 0 0-.208-.18.7.7 0 0 0-.318-.066h-.644zm0-1.486h.57a.7.7 0 0 0 .28-.055.47.47 0 0 0 .195-.16.4.4 0 0 0 .073-.246.4.4 0 0 0-.14-.318q-.139-.12-.394-.12h-.584zM15.07 17.5v-3.636h1.435q.413 0 .705.158.291.156.444.435.154.276.154.639 0 .361-.156.64a1.08 1.08 0 0 1-.453.43 1.5 1.5 0 0 1-.713.155h-.915v-.616h.79q.222 0 .366-.076a.5.5 0 0 0 .217-.215.7.7 0 0 0 .072-.318.66.66 0 0 0-.072-.316.5.5 0 0 0-.217-.211.8.8 0 0 0-.37-.077h-.518V17.5z"
  })));
};
export default SvgWebp;